/**
 * Remplacement local d'`AdnStatusEnum` / `AdnStatusIconPositionEnum` (@b2ag/design-system).
 *
 * Le design system exposait 4 familles de statuts (`OFFER`, `DISCOUNT`, `ORDER`, `LINE_ITEM`),
 * soit 16 valeurs. `front/seller` n'en consomme que 6 : on ne reprend que celles-là, typées.
 */
export type CStatusOffer = 'offer-active' | 'offer-upcoming' | 'offer-past'
export type CStatusLineItem = 'line-item-pending' | 'line-item-transit' | 'line-item-fulfilled'
export type CStatusValue = CStatusOffer | CStatusLineItem

export type CStatusIconPosition = 'left' | 'right'

export const CStatusEnum = {
  OFFER: {
    ACTIVE: 'offer-active',
    UPCOMING: 'offer-upcoming',
    PAST: 'offer-past',
  },
  LINE_ITEM: {
    PENDING: 'line-item-pending',
    TRANSIT: 'line-item-transit',
    FULFILLED: 'line-item-fulfilled',
  },
} as const satisfies Record<string, Record<string, CStatusValue>>

export const CStatusIconPositionEnum = {
  LEFT: 'left',
  RIGHT: 'right',
} as const satisfies Record<string, CStatusIconPosition>

export const C_STATUS_VALUES: CStatusValue[] = [
  ...Object.values(CStatusEnum.OFFER),
  ...Object.values(CStatusEnum.LINE_ITEM),
]

export const C_STATUS_ICON_POSITIONS: CStatusIconPosition[] = Object.values(CStatusIconPositionEnum)

export function isCStatusValue(value: unknown): value is CStatusValue {
  return C_STATUS_VALUES.includes(value as CStatusValue)
}
